// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { extractStylesToArray, isSafe } from "@insite/client-framework/Common/Utilities/isSafeStyles";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import AwardFill from "@store/Library/Components/Toolkit/Icons/Award/AwardFill";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import updateCssValue, { Operators } from "@toolkit/Framework/Common/Utilities/updateCssValue";
import parse from "html-react-parser";
import React from "react";
import { css } from "styled-components";

const enum fields {
    content = "content",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.content]: string;
    };
}

export interface ProgramBannerStyles {
    bannerContainer: GridContainerProps;
    bannerIcon?: IconPresentationProps;
    iconGridItem?: GridItemProps;
    contentGridItem?: GridItemProps;
}
const verticalGap = pxToRemArray([25, 25]);

const programBannerStyles: ProgramBannerStyles = {
    bannerContainer: {
        css: css`
            background: ${getColor("common.accent")};
            border-radius: 8px;
            padding: ${pxToRem(25)};
        `,
    },
    bannerIcon: {
        size: 72,
        css: css`
            color: ${getColor("primary.light")};
        `,
    },
    iconGridItem: {
        width: 2,
        css: css`
            justify-content: center;
            align-items: center;
        `,
    },
    contentGridItem: {
        width: 10,
        css: css`
            position: relative;
            color: ${getColor("primary.light")};
            padding-left: ${pxToRem(60)};

            &::before {
                content: "";
                display: block;
                position: absolute;
                left: 0;
                width: ${pxToRem(1)};
                background-color: ${getColor("common.border")};

                ${breakpointValues(
                    verticalGap.map((x: string | null) => updateCssValue(x, Operators.Divide, 2)),
                    ["top", "bottom"],
                )}
            }
        `,
    },
};

export const ProgramBanner: React.FunctionComponent<OwnProps> = ({ fields }) => {
    if (!fields.content) {
        return null;
    }

    const styles = programBannerStyles;

    const parsedContent = parse(fields.content, parserOptions);

    return (
        <GridContainer {...styles.bannerContainer}>
            <GridItem {...styles.iconGridItem}>
                <Icon {...styles.bannerIcon} src={AwardFill} />
            </GridItem>
            <GridItem {...styles.contentGridItem}>
                <Typography>{parsedContent}</Typography>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: ProgramBanner,
    definition: {
        group: "Common",
        icon: "text",
        fieldDefinitions: [
            {
                name: fields.content,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : "The HTML contains invalid styles that prevent it from being saved";
                },
            },
        ],
    },
};

export default widgetModule;
